/**
 * Upselling & Packaging Logik im Shopify Cart
 */
const EXCLUDED_GIFT_PRODUCT_HANDLES = [
  'decathlon',
  'h-m',
  'shop-apotheke',
  'adidas',
  'tk-maxx',
  'home24-gutschein',
  'rituals-gutschein',
  'butlers-gutschein'
];
document.addEventListener('DOMContentLoaded', () => {
    // The PDP also loads this file to reuse the fee reconciliation before its
    // confirmation preview. Packaging and page reloads belong to the cart page.
    if (!document.querySelector('cart-items')) return;
    attachCartEventListeners();
    fetchAndHandleCart();
  });
  
  function attachCartEventListeners() {
    ['onItemDeleted', 'onQuantityChange'].forEach(eventName => {
      document.addEventListener(eventName, fetchAndHandleCart);
    });
  }
  
  let cartRefreshPending;
  function fetchAndHandleCart() {
    if (cartRefreshPending) return cartRefreshPending;
    cartRefreshPending = validateLineItemsRelatedCover()
      .then(({ cart, changed }) => {
        if (changed) window.location.reload();
        else handleCartLoad(cart);
      })
      .catch(error => {
        console.error(error);
        const status = document.getElementById('cart-errors');
        if (status) status.textContent = 'Die Zusatzkosten konnten nicht aktualisiert werden. Bitte lade den Warenkorb erneut.';
      })
      .finally(() => { cartRefreshPending = null; });
    return cartRefreshPending;
  }

  function handleCartLoad(cart) {
    const settings = getUpsellingSettings();
    const packagingOptions = settings.packagingOptions || [];
    const packagingLimit = settings.general?.packaging_options_products_limit || Infinity;
    const upsellingLimit = settings.general?.upselling_limit || Infinity;
    const upsellingEnabled = settings.general?.upselling_enabled;
  
    const packagingSelector = document.querySelector("packaging-options-selector");
    const upsellingSection = document.querySelector('.upselling[data-section-upselling]');
    const checkoutButton = document.querySelector(".cart__checkout-button");
  
    const cartItemsCount = getValidCartItemCount(cart.items, packagingOptions);
  
    if (cart.items.length) checkoutButton?.removeAttribute("disabled");
  

  
    // Upselling Sichtbarkeit
    if (upsellingEnabled) {
      upsellingSection?.classList.toggle('hidden', cartItemsCount > upsellingLimit);
    }
  
    // Geschenkoptionen Sichtbarkeit
    if (cartItemsCount && cartItemsCount <= packagingLimit) {
      packagingSelector?.removeAttribute("hidden");
    }
  
    const { singleCollection, multiCollection } = splitPackagingCollections(packagingOptions);
  
    const cartHasPackagingItem = cart.items.some(item =>
      packagingOptions.some(opt => item.id === opt.variantId)
    );
  
    const cartSinglePackagingItems = cart.items.filter(item =>
      singleCollection.some(opt => item.id === opt.variantId)
    );
  
    const cartMultiPackagingItems = cart.items.filter(item =>
      multiCollection.some(opt => item.id === opt.variantId)
    );

  const hasDigitalOrPdfVoucher = cart.items.some(item =>
    // PDF-Erkennung
    item.properties?.Versandart === 'PDF' ||
    item.title?.toLowerCase().includes('pdf') ||
    item.product_title?.toLowerCase().includes('pdf') ||
    item.tags?.includes('PDF') ||
    // Digital-Erkennung
    item.handle?.toLowerCase().includes('digital') ||
    item.title?.toLowerCase().includes('digital') ||
    item.product_title?.toLowerCase().includes('digital')
  );

  const hasPhysicalVoucher = cart.items.some(item =>
    // Kein PDF, kein digitaler Artikel
    item.properties?.Versandart !== 'PDF' &&
    !item.title?.toLowerCase().includes('pdf') &&
    !item.product_title?.toLowerCase().includes('pdf') &&
    !item.tags?.includes('PDF') &&
    !item.handle?.toLowerCase().includes('digital') &&
    !item.title?.toLowerCase().includes('digital') &&
    !item.product_title?.toLowerCase().includes('digital') &&
    // Ausschlüsse
    item.properties._is_related_cover !== "true" &&
    !item.product_type?.includes("PPLR_HIDDEN_PRODUCT") &&
    !packagingOptions.some(opt => item.id === opt.variantId) &&
    item.handle !== "geschenkumschlag" &&
    item.product_handle !== "geschenkumschlag"
  );

  // Wenn NUR digitale oder PDF-Gutscheine im Warenkorb sind → Add-ons entfernen
  if (hasDigitalOrPdfVoucher && !hasPhysicalVoucher) {
    const updates = {};
    const addonItems = cart.items.filter(item =>
      packagingOptions.some(opt => item.id === opt.variantId)
    );

    if (addonItems.length > 0) {
      addonItems.forEach(addon => updates[addon.id] = 0);
      localStorage.setItem('pdfNotice', 'true');
      updateCart({ updates });
      return; // stoppt die weiteren Regeln
    }
  }

  /* --- NEUE REGEL: bestimmte Artikel (z.B. decathlon) dürfen nicht mit Zusatzgeschenken kombiniert werden --- */
  const hasExcludedGiftProduct = cart.items.some(item =>
    EXCLUDED_GIFT_PRODUCT_HANDLES.includes(item.handle) ||
    EXCLUDED_GIFT_PRODUCT_HANDLES.includes(item.product_handle)
  );

  // Produkte, bei denen Add-ons erlaubt sind (quasi "physische" Standardartikel)
  const hasGiftEligibleProduct = cart.items.some(item =>
    item.properties?.Versandart !== 'PDF' &&
    !item.title?.toLowerCase().includes('pdf') &&
    !item.product_title?.toLowerCase().includes('pdf') &&
    !item.tags?.includes('PDF') &&
    !item.handle?.toLowerCase().includes('digital') &&
    !item.title?.toLowerCase().includes('digital') &&
    !item.product_title?.toLowerCase().includes('digital') &&
    item.properties._is_related_cover !== "true" &&
    !item.product_type?.includes("PPLR_HIDDEN_PRODUCT") &&
    !packagingOptions.some(opt => item.id === opt.variantId) &&
    item.handle !== "geschenkumschlag" &&
    item.product_handle !== "geschenkumschlag" &&
    !EXCLUDED_GIFT_PRODUCT_HANDLES.includes(item.handle) &&
    !EXCLUDED_GIFT_PRODUCT_HANDLES.includes(item.product_handle)
  );

  // Wenn NUR ausgeschlossene Artikel (z.B. decathlon) + Add-ons im Warenkorb sind → Add-ons entfernen
  if (hasExcludedGiftProduct && !hasGiftEligibleProduct) {
    const updates = {};
    const addonItems = cart.items.filter(item =>
      packagingOptions.some(opt => item.id === opt.variantId)
    );

    if (addonItems.length > 0) {
      addonItems.forEach(addon => updates[addon.id] = 0);
      localStorage.setItem('excludedGiftNotice', 'true');
      updateCart({ updates });
      return; // stoppt die weiteren Regeln – analog zur PDF-Regel
    }
  }
  
    if (cartHasPackagingItem) {
      if (cartItemsCount === 1 && cartSinglePackagingItems.length) {
        disableQuantityInputs(cartSinglePackagingItems);
      }

      /* --- Automatische Reduktion von Packaging-Optionen --- */
  const updates = {}; // 🟢 hier nach außen ziehen

  const packagingItems = cart.items.filter(item =>
    packagingOptions.some(opt => item.id === opt.variantId)
  );

  // 🔓 Ausnahme
  const giftBoxItems = packagingItems.filter(item =>
    item.handle === "geschenkbox" || item.product_handle === "geschenkbox"
  );

  // ❗ alle anderen Add-ons (alte Logik!)
  const normalPackagingItems = packagingItems.filter(item =>
    item.handle !== "geschenkbox" && item.product_handle !== "geschenkbox"
  );

  const normalPackagingCount = normalPackagingItems.reduce((sum, item) => sum + item.quantity, 0);
  const giftBoxCount = giftBoxItems.reduce((sum, item) => sum + item.quantity, 0);

  // Nur physische Gutscheine zählen
  const standardCount = cart.items
    .filter(item =>
      item.properties?.Versandart !== 'PDF' &&
      !item.title?.toLowerCase().includes('pdf') &&
      !item.product_title?.toLowerCase().includes('pdf') &&
      !item.tags?.includes('PDF') &&
      !item.handle?.toLowerCase().includes('digital') &&
      !item.title?.toLowerCase().includes('digital') &&
      !item.product_title?.toLowerCase().includes('digital') &&
      item.properties._is_related_cover !== "true" &&
      !item.product_type?.includes("PPLR_HIDDEN_PRODUCT") &&
      !packagingOptions.some(opt => item.id === opt.variantId) &&
      item.handle !== "geschenkumschlag" &&
      item.product_handle !== "geschenkumschlag" &&
      !EXCLUDED_GIFT_PRODUCT_HANDLES.includes(item.handle) &&
      !EXCLUDED_GIFT_PRODUCT_HANDLES.includes(item.product_handle)
    )
    .reduce((sum, item) => sum + item.quantity, 0);

  // ✅ ALTE LOGIK: alle normalen Add-ons 1:1
  if (normalPackagingCount > standardCount) {
    let excess = normalPackagingCount - standardCount;

    for (const item of normalPackagingItems) {
      if (excess <= 0) break;

      if (item.quantity <= excess) {
        updates[item.id] = 0;
        excess -= item.quantity;
      } else {
        updates[item.id] = item.quantity - excess;
        excess = 0;
      }
    }

    localStorage.setItem('addonNotice', 'true');
  }

  const giftBoxLimit = standardCount > 0 ? standardCount + 9 : 0;

  if (giftBoxCount > giftBoxLimit) {
    let excess = giftBoxCount - giftBoxLimit;

    for (const item of giftBoxItems) {
      if (excess <= 0) break;

      if (item.quantity <= excess) {
        updates[item.id] = 0;
        excess -= item.quantity;
      } else {
        updates[item.id] = item.quantity - excess;
        excess = 0;
      }
    }

    localStorage.setItem('addonNotice', 'true');
  }

  /* --- NEUE REGEL: "geschenkumschlag" nur mit genau 1 Gutschein --- */
  const envelopeLine = cart.items.find(item =>
    item.handle === "geschenkumschlag" || item.product_handle === "geschenkumschlag"
  );

  if (envelopeLine) {
    const voucherCount = cart.items
      .filter(item =>
        item.properties._is_related_cover !== "true" &&
        !item.product_type.includes("PPLR_HIDDEN_PRODUCT") &&
        !packagingOptions.some(opt => item.id === opt.variantId) &&
        item.handle !== "geschenkumschlag" && item.product_handle !== "geschenkumschlag"
      )
      .reduce((sum, item) => sum + item.quantity, 0);

    if (voucherCount > 1) {
      updates[envelopeLine.id] = 0; 
      localStorage.setItem("envelopeNotice", "true");
    }
  }

  /* --- NUR EIN Aufruf am Ende --- */
  if (Object.keys(updates).length > 0) {
    updateCart({ updates });
  }
  
/* --- AUSKOMMENTIERT: automatische Entfernung von Packaging-Optionen ---
      const shouldRemovePackaging =
        (cartItemsCount === 1 && cartMultiPackagingItems.length) ||
        (cartItemsCount > 1 && cartSinglePackagingItems.length) ||
        cartItemsCount === 0 ||
        (upsellingEnabled && cartItemsCount > upsellingLimit);
  
      if (shouldRemovePackaging) {
        handleInvalidCart(packagingOptions.map(p => p.variantId));
      }
      --- ENDE AUSKOMMENTIERT --- */ 
    }
  let digitalExperienceCount = 0;
  const digitalExperienceItems = [];

  cart.items.forEach((element, index) => {
    if (element.properties['Thumbnail-Image']) {
      digitalExperienceCount += 1;
      digitalExperienceItems.push({ element: element, index: index });
    }
  });

  if (digitalExperienceCount > 0) {
    digitalExperienceItems.forEach(element => {
      onlyDisableQuantityInputs(element.index, element.element, digitalExperienceCount);
    });
  }
  }
  
  function getValidCartItemCount(items, packagingOptions) {
    return items.filter(item =>
      item.properties._is_related_cover !== "true" &&
      !item.product_type.includes("PPLR_HIDDEN_PRODUCT") &&
      !packagingOptions.some(opt => item.id === opt.variantId)
    ).reduce((sum, item) => sum + item.quantity, 0);
  }
  
  function disableQuantityInputs(items) {
    items
      // 1) Geschenkbox rausfiltern
      .filter(item =>
        item.handle !== "geschenkbox" &&
        item.product_handle !== "geschenkbox"
      )
      .forEach(item => {
        const input = document.querySelector(`.quantity__input[data-variant-id="${item.id}"]`);
        // 2) Guard, falls kein Input gefunden wird
        if (!input) return;

        input.disabled = true;

        ['plus', 'minus'].forEach(name => {
          const btn = input.parentElement.querySelector(`button[name="${name}"]`);
          if (btn) {
            btn.disabled = true;
            btn.classList.add("disabled");
          }
        });
      });
  }
  function onlyDisableQuantityInputs(index, item, digitalExperienceCount) {
    const input = document.querySelector(`tr[data-voucher-id="${item.properties['Produkt-ID']}"] input`);
    if (!input) return;
    input.disabled = true;
    const btn = input.parentElement.querySelector(`button[name="minus"]`);
    if (btn && digitalExperienceCount > 1) {
      btn.disabled = false;
      btn.classList.remove("disabled");
      btn.addEventListener('click', () => {
        removeItemFromCart(index);
      });
    }
  }

  function removeItemFromCart(index) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: index + 1, quantity: 0 })
    })
    .then(res => res.json())
    .then(() => setTimeout(() => window.location.reload(), 300))
    .catch(console.error);
  }

  function handleInvalidCart(variantIds) {
    const updates = {};
    variantIds.forEach(id => updates[id] = 0);
    updateCart({ updates });
  }
  
  function updateCart(data) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(res => res.json())
      .then(() => setTimeout(() => window.location.reload(), 300))
      .catch(console.error);
  }
  
  function addToCart(variantId, quantity, properties = null) {
    const payload = { id: variantId, quantity };
    if (properties) payload.properties = properties;
  
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(res => res.json())
      .then(() => setTimeout(() => window.location.reload(), 300))
      .catch(console.error);
  }
  
  // Keep the original cover/service selection; the app handles inside fees separately.
  // New motif fees are native Shopify children. Existing fees keep their current link.
  // The native relationship survives edits even when a voucher has no app fee group.
  function relatedFeePlan(items) {
    const updates = {};
    const additions = [];
    const propertyChanges = [];
    for (const parent of items) {
      const coverId = String(parent.properties?._related_cover || '');
      const serviceId = String(parent.properties?._related_servicefee || '');
      const variantId = coverId || serviceId;
      if (!variantId) continue;
      const flag = coverId ? '_is_related_cover' : '_is_related_servicefee';
      const group = parent.properties?._ew_fee_group;
      const child = items.find(item => {
        if (String(item.variant_id || item.id) !== variantId || item.properties?.[flag] !== 'true') return false;
        const nativeParentKey = item.parent_relationship?.parent_key;
        if (nativeParentKey) return nativeParentKey === parent.key;
        return item.properties._parent_key === parent.key ||
          (group && item.properties._wgs_parent_group === group);
      });
      if (!child) {
        additions.push({ id: variantId, quantity: parent.quantity,
          ...(coverId ? { parent_line_key: parent.key } : {}), properties: {
          [flag]: 'true', _parent_key: parent.key, ...(group ? { _wgs_parent_group: group } : {})
        } });
      } else if (child.properties._parent_key !== parent.key || (group && child.properties._wgs_parent_group !== group)) {
        propertyChanges.push({ id: child.key, quantity: parent.quantity,
          properties: { ...child.properties, _parent_key: parent.key, ...(group ? { _wgs_parent_group: group } : {}) } });
      } else if (child.quantity !== parent.quantity) {
        updates[child.key] = parent.quantity;
      }
    }
    return { updates, additions, propertyChanges };
  }

  let relatedValidationPending;
  function validateLineItemsRelatedCover() {
    if (relatedValidationPending) return relatedValidationPending;
    relatedValidationPending = (async () => {
      const route = path => `${(window.Shopify?.routes?.root || '/').replace(/\/+$/, '')}/${path}`;
      async function request(path, data) {
        const response = await fetch(route(path), {
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          ...(data ? { method: 'POST', body: JSON.stringify(data) } : {})
        });
        const body = await response.json();
        if (!response.ok) throw new Error(body.description || 'Zusatzkosten konnten nicht aktualisiert werden.');
        return body;
      }
      let changed = false;
      for (let pass = 0; pass < 5; pass++) {
        const cart = await request('cart.js');
        const { updates, additions, propertyChanges } = relatedFeePlan(cart.items);
        if (!Object.keys(updates).length && !additions.length && !propertyChanges.length) return { cart, changed };
        if (propertyChanges.length) {
          for (const change of propertyChanges) await request('cart/change.js', change);
        } else if (Object.keys(updates).length) {
          await request('cart/update.js', { updates });
        } else {
          await request('cart/add.js', { items: additions });
        }
        changed = true;
      }
      throw new Error('Zusatzkosten konnten nicht abgeglichen werden. Bitte lade den Warenkorb erneut.');
    })().finally(() => { relatedValidationPending = null; });
    return relatedValidationPending;
  }

  function splitPackagingCollections(options) {
    return {
      singleCollection: options.filter(o => o.collectionHandle === "geschenkoption-einzelversand"),
      multiCollection: options.filter(o => o.collectionHandle === "geschenkoption-massenversand")
    };
  }
  
  function getUpsellingSettings() {
    const el = document.querySelector('[data-upselling-settings]');
    try {
      return JSON.parse(el?.textContent || "{}");
    } catch {
      return {};
    }
  }
  
